
import Footer from './Footer';
import Header from './Header';

function About(lang) {
    if(lang.lang==="pl"){
        return (
            <div className="App">
                <Header/>
                <br />
                <h1>O Nas</h1>
                <br />
                <div className='midbody'>
    
                    <div className='midblock' id='midblock1'>
                        <h4>NASZA FIRMA W LICZBACH.</h4>
                        <h1>Poznaj nas bliżej</h1>
                        <br />
                        <h3>Nasza firma, "TELETEL BiznesPlus", powstała z myślą o wspieraniu przedsiębiorców oraz obcokrajowców, którzy chcą realizować swoje marzenia biznesowe w Polsce.</h3>
                        <h3>Od 2015 roku oferujemy:</h3>
                        <h3>- kompleksowe usługi księgowe w ramach prowadzenia działalności gospodarczej oraz Spółek</h3>
                        <h3>- doradztwo biznesowe, wybór rodzaju działalności, forma opodatkowania</h3>
                        <h3>- legalizacji działalności,</h3>
                        <h3>- wsparcie dla obcokrajowców w zakresie uzyskania zezwoleń na pobyt i pracę</h3>
                        <h3>Nasz zespół wykwalifikowanych specjalistów dostosowuje usługi do indywidualnych potrzeb klientów, zapewniając profesjonalizm i rzetelność na każdym etapie współpracy. Jesteśmy partnerem, który angażuje się w realizację celów naszych klientów.</h3>
                        <h3>Zapraszamy do zapoznania się z naszą ofertą na stronie internetowej i skorzystania z naszych usług.</h3>
    
                    </div>
                    <div className='midblock' id='midblock2'>
                        <img src='/midsplash2.webp' alt='co-working' />
                        <div className='overimg' id='overimg1'><br /><h2>+20</h2><h5>Specjaliści</h5></div>
                        <div className='overimg' id='overimg2'><br /><h2>+15</h2><h5>Zrealizowane projekty</h5></div>
                        <div className='overimg' id='overimg3'><br /><h2>+227</h2><h5>Zadowoleni klienci</h5></div>
                    </div>
                </div>
                <br />
                <div className='aboutserviceblock'>
                        <img src='/checkmark.webp' alt='checkmark'/>
                        <img src='/checkmark.webp' alt='checkmark'/>
                        <h3>Kompleksowa oferta</h3>
                        <h3>Indywidualne podejście</h3>
                        <h4>" TELETEL" oferuje szeroki wachlarz usług, w tym księgowość, doradztwo biznesowe oraz pomoc w legalizacji działalności i pobytu, co sprawia, że klienci mogą skorzystać z jednego miejsca na wszystkie swoje potrzeby biznesowe.</h4>
                        <h4>Zespół specjalistów "TELETEL" dostosowuje usługi do specyficznych potrzeb i oczekiwań każdego klienta, co zapewnia efektowne wsparcie na każdym etapie prowadzenia działalności, umożliwiając osiągnięcie zamierzonych celów biznesowych.</h4>
                </div>
                <Footer/>
            </div>
        );
    }
    if(lang.lang==="ua"){
        return (
            <div className="App">
                <Header/>
                <br />
                <h1>Про компанію</h1>
                <br />
                <div className='midbody'>
    
                    <div className='midblock' id='midblock1'>
                        <br/>
                        <h1>Познайомтеся з нами ближче</h1>
                        <br />
                        <h3>Наша компанія була створена з метою підтримки підприємців та іноземців, які хочуть реалізувати свої бізнес-мрії в Польщі. З 2015 року ми пропонуємо комплексні Бухгалтерські послуги, Бізнес-Консалтинг, допомогу в легалізації бізнесу та підтримку іноземцям в отриманні посвідки на проживання. Наша команда кваліфікованих фахівців адаптує послуги до індивідуальних потреб клієнтів, забезпечуючи професіоналізм і надійність на кожному етапі співпраці. Ми є партнером, який прагне досягти цілей наших клієнтів. Ми запрошуємо вас ознайомитися з нашою пропозицією на сайті і скористатися нашими послугами.</h3>
    
                    </div>
                    <div className='midblock' id='midblock2'>
                        <img src='/midsplash2.webp' alt='co-working' />
                        <div className='overimg' id='overimg1'><br /><h2>+20</h2><h5>Спеціалісти</h5></div>
                        <div className='overimg' id='overimg2'><br /><h2>+15</h2><h5>Завершені проекти</h5></div>
                        <div className='overimg' id='overimg3'><br /><h2>+227</h2><h5>Задоволені клієнти</h5></div>
                    </div>
                </div>
                <br />
                <div className='aboutserviceblock'>
                        <img src='/checkmark.webp' alt='checkmark'/>
                        <img src='/checkmark.webp' alt='checkmark'/>
                        <h3>Комплексна пропозиція</h3>
                        <h3>Індивідуальний підхід</h3>
                        <h4>Наша компанія пропонує широкий спектр послуг, включаючи Бухгалтерський облік, бізнес-консалтинг та допомогу в легалізації бізнесу та проживання, що дозволяє клієнтам використовувати одне місце для всіх своїх бізнес-потреб.</h4>
                        <h4>Команда фахівців "Teletel" адаптує послуги до конкретних потреб і очікувань кожного клієнта, що забезпечує ефектну підтримку на кожному етапі ведення бізнесу, дозволяючи досягти намічених бізнес-цілей.</h4>
                </div>
                <Footer/>
            </div>
        );
    }
    
}

export default About;
